module.exports = "<div class=\"static-row row {{remove ? 'action-deleting' : ''}}\">\n  <div class=\"col-xs-12\">\n    <span>{{blankVal(email)|e}}</span>\n  </div>\n</div>\n";
